import {FC, useState} from 'react'

import {HeaderMainButtonProps} from '@/components/header/HeaderMainButton'
import {KnowledgeBaseHeader} from '@/components/knowledge-base/header/KnowledgeBaseHeader'
import {KnowledgeBaseHeaderSearch} from '@/components/knowledge-base/header/KnowledgeBaseHeaderSearch'
import {getTmAcademyContent} from '@/content/tm-academy/tmAcademy'
import {useTranslation} from '@/i18n'
import {AcademyContents} from '@/utils/contentful'
import {useLanguage} from '@/utils/i18n/language'

import {AcademyMobileNavigation} from './AcademyMobileNavigation'
import {useAcademySearch} from './useAcademySearch'

type AcademyHeaderProps = {
  contents: AcademyContents
  mainCtaButton?: HeaderMainButtonProps
}

export const AcademyHeader: FC<React.PropsWithChildren<AcademyHeaderProps>> = ({
  contents,
  mainCtaButton,
}) => {
  const language = useLanguage()
  const {t} = useTranslation()

  const {academyLinkText} = getTmAcademyContent(language).header
  const [isMobileNavigationActive, setMobileNavigationActive] = useState(false)
  const {query, setQuery, articleLinks} = useAcademySearch(contents)

  return (
    <KnowledgeBaseHeader
      title={t(academyLinkText)}
      searchInput={
        <KnowledgeBaseHeaderSearch data={articleLinks} query={query} setQuery={setQuery} />
      }
      isMobileNavigationActive={isMobileNavigationActive}
      setMobileNavigationActive={setMobileNavigationActive}
      mobileNavigation={
        <AcademyMobileNavigation
          isActive={isMobileNavigationActive}
          setMobileNavigationActive={setMobileNavigationActive}
          contents={contents}
        />
      }
      mainCtaButton={mainCtaButton}
    />
  )
}
